module.exports = "<symbol id=\"tt-icon-settings\" viewBox=\"0 0 24 24\"><path d=\"M23.75 14v-4h-2.16a9.65 9.65 0 0 0-1.43-3.43l1.53-1.54-2.76-2.73-1.54 1.54A9.65 9.65 0 0 0 14 2.41V.25h-4v2.16a9.73 9.73 0 0 0-3.39 1.43L5.08 2.31 2.31 5.08l1.53 1.53A9.65 9.65 0 0 0 2.41 10H.25v4h2.16a9.49 9.49 0 0 0 1.44 3.43l-1.54 1.5 2.77 2.76 1.53-1.53a9.7 9.7 0 0 0 3.44 1.43v2.16H14v-2.16a9.76 9.76 0 0 0 3.43-1.43l1.54 1.53 2.76-2.77-1.53-1.53A9.73 9.73 0 0 0 21.59 14zM12 18.53A6.53 6.53 0 1 1 18.53 12 6.53 6.53 0 0 1 12 18.53z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/settings.svg
// module id = 222
// module chunks = 9